/* Landing Pantalón Táctico Rescate · KMARG
   Estado compartido de color / talla / cantidad + animaciones de la referencia.
   Sin librerías: CSS, IntersectionObserver y requestAnimationFrame. Un solo listener de scroll. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Datos del producto ---------- */
  var data = null;
  var byKey = {};
  var state = { color: null, size: null, qty: 1, bundle: null };

  function loadData() {
    var el = $('script[data-res-product]');
    if (!el) return false;
    try { data = JSON.parse(el.textContent); } catch (e) { return false; }
    byKey = {};
    data.variants.forEach(function (v) { byKey[v.color + '|' + v.size] = v; });
    return true;
  }
  function findVariant() { return byKey[state.color + '|' + state.size] || null; }
  function colorInfo(name) {
    for (var i = 0; i < data.colors.length; i++) if (data.colors[i].name === name) return data.colors[i];
    return data.colors[0];
  }

  /* ---------- Render del estado ---------- */
  function setText(sel, txt) { $$(sel).forEach(function (e) { e.textContent = txt; }); }

  function render(opts) {
    if (!data) return;
    opts = opts || {};
    var c = colorInfo(state.color);
    var v = findVariant();

    $$('[data-res-color]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-res-color') === c.name ? 'true' : 'false'); });
    setText('[data-res-color-name]', c.name);
    setText('[data-res-color-name-up]', c.name.toUpperCase());
    setText('[data-res-color-code]', c.code);
    $$('[data-res-bar-dot]').forEach(function (e) { e.style.background = 'var(--res-sw-' + c.index + ')'; });

    // Fotos (hero con fundido cruzado y resumen del pedido)
    $$('[data-res-stack]').forEach(function (stack) {
      $$('img[data-res-c]', stack).forEach(function (im) {
        var on = im.getAttribute('data-res-c') === c.name;
        if (on && im.loading === 'lazy') im.loading = 'eager';
        im.classList.toggle('res-on', on);
      });
    });

    // Galería del hero: la del color elegido, desde la primera foto
    $$('[data-res-gal]').forEach(function (g) {
      var on = g.getAttribute('data-res-gal') === c.name;
      clearTimeout(g.__reshide);
      if (on && !g.classList.contains('res-on')) {
        $$('.res-gal-slide img[loading="lazy"]', g).slice(0, 2).forEach(function (im) { im.loading = 'eager'; });
        g.classList.add('res-show');
        var tr = $('.res-gal-track', g);
        if (tr) tr.scrollLeft = 0;
        void g.offsetWidth; // aplica display antes de fundir
        g.classList.add('res-on');
        if (tr && tr.__resupdate) tr.__resupdate();
      } else if (!on && g.classList.contains('res-on')) {
        g.classList.remove('res-on');
        g.__reshide = setTimeout(function () { g.classList.remove('res-show'); }, reduce ? 0 : 750);
      }
    });

    // Tallas: tachadas si la variante de ese color está agotada
    $$('[data-res-size]').forEach(function (b) {
      var s = b.getAttribute('data-res-size');
      var vv = byKey[c.name + '|' + s];
      var available = !!(vv && vv.available);
      b.disabled = !available;
      b.setAttribute('aria-pressed', s === state.size ? 'true' : 'false');
      b.setAttribute('aria-label', available ? 'Talla ' + s : 'Talla ' + s + ' agotada');
    });
    $$('[data-res-size-label]').forEach(function (e) { e.textContent = state.size || e.getAttribute('data-res-empty') || '—'; });
    if (state.size) $$('[data-res-size-hint]').forEach(function (e) { e.hidden = true; });

    // Precios
    if (v) {
      setText('[data-res-price-now]', v.price);
      $$('[data-res-price-was]').forEach(function (e) { e.textContent = v.compare || ''; e.hidden = !v.compare; });
      $$('[data-res-price-save]').forEach(function (e) {
        var tpl = e.getAttribute('data-res-template') || '';
        e.textContent = v.save ? tpl.replace('[monto]', v.save) : '';
      });
    }

    // Combos y total
    var bundles = $$('[data-res-bundle]');
    bundles.forEach(function (b) { b.setAttribute('aria-pressed', b === state.bundle ? 'true' : 'false'); });
    if (state.bundle) {
      setText('[data-res-total]', state.bundle.getAttribute('data-price'));
      setText('[data-res-qty-label]', state.bundle.getAttribute('data-title'));
    } else {
      // Sin combo: 1 unidad al precio de la variante (o del color, si aún no hay talla)
      var pv = v || data.variants.filter(function (x) { return x.color === c.name; })[0];
      if (pv) setText('[data-res-total]', pv.price);
      $$('[data-res-qty-label][data-res-single]').forEach(function (e) { e.textContent = e.getAttribute('data-res-single'); });
    }

    // Formulario nativo
    var form = $('[data-res-form]');
    if (form) {
      var idInput = $('input[name="id"]', form);
      var qtyInput = $('input[name="quantity"]', form);
      // Sin eventos: Releasit lee nuestros inputs con cada change y fijaría una variante desactualizada
      if (qtyInput && String(qtyInput.value) !== String(state.qty)) qtyInput.value = state.qty;
      var ok = !!(v && v.available);
      $$('[data-res-submit]', form).forEach(function (b) { b.disabled = !ok; });
      $$('[data-res-soldout]').forEach(function (e) { e.hidden = ok || !state.size; });
      if (v && idInput && String(state.variantId) !== String(v.id)) {
        state.variantId = v.id;
        if (!opts.silent) {
          // Primero la URL: Releasit rehace su carrito con la variante de ?variant=
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, color: c.name, size: state.size, quantity: state.qty } }));
        }
        setFormVariantWhenCodReady(idInput, v.id);
      }
    }
  }

  /* ---------- Ofertas por cantidad de la app COD (Releasit) ----------
     Releasit fija la cantidad que lee al abrir su formulario por primera vez. Si el producto no tiene ofertas en la app,
     los combos se ocultan y siempre va 1 unidad; si las tiene, solo quedan los combos con esas cantidades. */
  var codQtys = null;
  function readCodOffers() {
    var list = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!window._RSI_COD_FORM_SETTINGS || !Array.isArray(list)) return null;
    var form = $('[data-res-form]');
    var pidEl = form && $('input[name="product-id"]', form);
    var pid = pidEl ? String(pidEl.value) : '';
    var q = [];
    list.forEach(function (g) {
      if (!g || g.isActive === false) return;
      if (Array.isArray(g.pIds) && g.pIds.length && g.pIds.map(String).indexOf(pid) < 0) return;
      (g.offers || []).forEach(function (o) { var n = +o.qty; if (n && q.indexOf(n) < 0) q.push(n); });
    });
    return q;
  }
  function applyCodOffers() {
    if (!data) return false;
    var q = readCodOffers();
    if (q === null) return false;
    codQtys = q;
    var bundles = $$('[data-res-bundle]');
    bundles.forEach(function (b) { b.hidden = q.indexOf(+b.getAttribute('data-qty')) < 0; });
    $$('[data-res-bundles]').forEach(function (g) { g.hidden = !bundles.some(function (b) { return !b.hidden; }); });
    if (state.bundle && state.bundle.hidden) {
      var vis = bundles.filter(function (b) { return !b.hidden; });
      state.bundle = vis.filter(function (b) { return b.hasAttribute('data-default'); })[0] || vis[0] || null;
    }
    state.qty = state.bundle ? (+state.bundle.getAttribute('data-qty') || 1) : 1;
    render({ silent: true });
    return true;
  }

  /* Releasit (formulario COD en ventana) toma la variante de ?variant= y con ella rehace su carrito, pero solo si es
     distinta de la que ya tiene anotada. Nuestro input[name="id"] se actualiza cuando Releasit ya cambió, para que no
     la anote antes de tiempo (eso dejaba el pedido con la primera variante). */
  function setFormVariantWhenCodReady(input, id) {
    clearTimeout(input.__rest);
    var n = 0;
    (function check() {
      var api = window._rsiV2, cur = null;
      try { cur = api && api.getState ? api.getState().currentVariantId : null; } catch (e) {}
      if (!api || String(cur) === String(id) || ++n > 30) {
        // También el formulario propio de Releasit: su botón lee ese input al abrir y, si quedara con la
        // primera variante, rehace el carrito con ella
        var pid = input.form && input.form.querySelector('[name="product-id"]');
        $$('form[action*="/cart/add"] input[name="id"]').forEach(function (el) {
          var p = el.form && el.form.querySelector('[name="product-id"]');
          if (!pid || !p || p.value === pid.value) el.value = id;
        });
        return;
      }
      input.__rest = setTimeout(check, 100);
    })();
  }

  function initState() {
    if (!loadData()) return;
    var form = $('[data-res-form]');
    var idInput = form && $('input[name="id"]', form);
    var start = null;
    if (idInput) data.variants.forEach(function (v) { if (String(v.id) === String(idInput.value)) start = v; });
    start = start || data.variants.filter(function (v) { return v.id === data.initial; })[0] || data.variants[0];
    state.color = start.color;
    state.variantId = idInput ? idInput.value : null;
    // Sin talla preseleccionada (salvo ?variant= o ajuste): el cliente debe elegirla.
    state.size = form && form.getAttribute('data-res-size-chosen') === 'false' ? null : start.size;
    var pre = $('[data-res-bundle][data-default]') || $('[data-res-bundle]');
    state.bundle = pre || null;
    state.qty = pre ? (+pre.getAttribute('data-qty') || 1) : 1;
    render({ silent: true });
    // Si la variante inicial no es la que Shopify toma por defecto (p. ej. talla preseleccionada),
    // se refleja en la URL y se avisa con change para que la app COD la lea.
    if (idInput && String(start.id) !== String(data.initial)) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', start.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- Compra directa: los botones [data-res-buy] abren el formulario COD ---------- */
  var COD_BTN = '.rsi-app-block-container button, [class*="_rsi-buy-now-button"] button, button[class*="_rsi-buy-now"]';
  function inView(el) { var r = el.getBoundingClientRect(); return r.top >= 0 && r.bottom <= window.innerHeight; }
  // Sin talla: no se abre el formulario; se resaltan las tallas (las del hero o las del pedido).
  function requireSize(where) {
    // Si ya hay un selector de talla a la vista, se usa ese; si no, el indicado (hero o pedido).
    var seen = $$('[data-res-size-group]').filter(function (g) { var r = g.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; })[0];
    var group = seen || $('[data-res-size-group="' + where + '"]') || $('[data-res-size-group="pedido"]') || $('[data-res-size-group]');
    if (!group) return;
    $$('[data-res-size-hint]').forEach(function (e) { e.hidden = false; });
    if (!inView(group)) group.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    group.classList.remove('res-attn'); void group.offsetWidth; group.classList.add('res-attn');
    var first = $('.res-sz:not([disabled])', group);
    if (first) first.focus({ preventScroll: true });
  }
  // Botón visible de la app. Nunca un submit: Releasit incluye un botón "Add" oculto que agrega al carrito.
  function findCodBtn() {
    var list = $$(COD_BTN).filter(function (b) { return b.type !== 'submit'; });
    var vis = list.filter(function (b) { return b.offsetParent !== null; });
    return vis[0] || list[0] || null;
  }
  function canOrder() { var v = findVariant(); return !!(state.size && v && v.available); }
  function openCod(where) {
    if (!state.size) { requireSize(where); return; }
    var v = findVariant();
    if (!v || !v.available) { requireSize(where); $$('[data-res-soldout]').forEach(function (e) { e.hidden = false; }); return; }
    // Se abre después de que termine este clic (si no, la app lo toma como "clic fuera" y cierra el formulario).
    // La app vuelve a dibujar su botón al cambiar la variante: se busca en el momento y se reintenta si no abrió.
    if (findCodBtn()) {
      (function tryOpen(n) {
        setTimeout(function () {
          var btn = findCodBtn();
          if (!btn) return;
          btn.click();
          setTimeout(function () {
            var dlg = document.getElementById('rsi_form_wrapper');
            if ((!dlg || !dlg.open) && n < 3) tryOpen(n + 1);
          }, 700);
        }, n ? 150 : 0);
      })(0);
      return;
    }
    var target = document.getElementById('pedido');
    if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  // Guarda: los botones de la app (bloque, flotante) tampoco abren el formulario sin talla elegida.
  // No toca los botones dentro del formulario de la app (enviar pedido, cerrar).
  var COD_ANY = COD_BTN + ', button.rsi_floating, button[class*="rsi_animation"]';
  window.addEventListener('click', function (e) {
    if (!data || !e.isTrusted) return;
    if (!e.target.closest(COD_ANY) || e.target.closest('#rsi_form_wrapper, dialog')) return;
    if (!canOrder()) { e.preventDefault(); e.stopImmediatePropagation(); requireSize('pedido'); }
  }, true);

  /* ---------- Formulario COD (Releasit): marca la oferta igual al combo elegido ---------- */
  function syncCodOffer() {
    if (!state.bundle) return;
    var tries = 0;
    (function poll() {
      var radios = document.querySelectorAll('input[name="quantity_offer"]');
      var idx = codQtys && codQtys.length ? codQtys.indexOf(state.qty) : state.qty - 1;
      var target = radios[idx];
      if (target) {
        if (!target.checked) (target.closest('label') || target).click();
        return;
      }
      if (++tries < 30) setTimeout(poll, 100);
    })();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest(COD_ANY) && !e.target.closest('#rsi_form_wrapper, dialog')) syncCodOffer();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-res-buy], [data-res-color], [data-res-size], [data-res-bundle], a[href="#pedido"]');
    if (!t) return;
    if (t.hasAttribute('data-res-buy') && data) { e.preventDefault(); e.stopPropagation(); openCod(t.getAttribute('data-res-buy')); return; }
    if (t.matches('a[href="#pedido"]')) {
      var target = document.getElementById('pedido');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      return;
    }
    if (!data) return;
    if (t.hasAttribute('data-res-color')) {
      state.color = t.getAttribute('data-res-color');
      if (t.classList.contains('res-ccard')) {
        var h = $('[data-res-hero]');
        if (h) h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    }
    if (t.hasAttribute('data-res-size')) { if (t.disabled) return; state.size = t.getAttribute('data-res-size'); }
    if (t.hasAttribute('data-res-bundle')) { state.bundle = t; state.qty = +t.getAttribute('data-qty') || 1; }
    render();
  });

  /* ---------- Galería del hero: deslizar con el dedo o con flechas ---------- */
  function initGallery(root) {
    $$('[data-res-gal]', root).forEach(function (g) {
      if (g.__resgal) return;
      g.__resgal = true;
      var track = $('.res-gal-track', g);
      var slides = $$('.res-gal-slide', g);
      var dots = $$('.res-gal-dots i', g);
      var prev = $('[data-res-gal-prev]', g), next = $('[data-res-gal-next]', g);
      if (!track || slides.length < 2) return;
      function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function update() {
        var i = Math.max(0, Math.min(slides.length - 1, index()));
        dots.forEach(function (d, k) { d.classList.toggle('res-on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        // Precarga la siguiente foto
        var nx = slides[i + 1] && $('img', slides[i + 1]);
        if (nx && nx.loading === 'lazy') nx.loading = 'eager';
      }
      // Destino calculado por índice (scrollBy con scroll-snap a veces se queda en la misma foto)
      var target = 0;
      function go(d) {
        var from = track.__resmoving ? target : index();
        target = Math.max(0, Math.min(slides.length - 1, from + d));
        track.__resmoving = true;
        clearTimeout(track.__resmt);
        track.__resmt = setTimeout(function () {
          track.__resmoving = false;
          if (index() !== target) track.scrollLeft = target * track.clientWidth; // respaldo si el desplazamiento suave no llegó
          update();
        }, 600);
        track.scrollTo({ left: target * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
      // La posición de la pista se lee en el listener único de scroll (captura) y al terminar el desplazamiento
      track.__resupdate = update;
      track.addEventListener('scrollend', update, { passive: true });
      update();
    });
  }

  /* ---------- Revelado al entrar en pantalla ---------- */
  var io = null;
  function count(el) {
    var n = el.querySelector('[data-res-count]');
    if (!n || reduce) return;
    var to = +n.getAttribute('data-res-count'), pad = +n.getAttribute('data-res-pad') || 1, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / 1100), v = Math.round(to * (1 - Math.pow(1 - p, 3)));
      n.textContent = String(v).padStart(pad, '0');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initReveal(root) {
    if (reduce || designMode || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.remove('res-is-pre'); io.unobserve(en.target); count(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    var vh = window.innerHeight;
    // Solo se oculta lo que empieza fuera de pantalla: lo visible al cargar nunca arranca oculto.
    $$('[data-res-reveal], [data-res-reveal-strip]', root).forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 0.95) { el.classList.add('res-is-pre'); io.observe(el); }
    });
  }

  /* ---------- Manifiesto palabra por palabra ---------- */
  var scrubs = [];
  function initScrub(root) {
    $$('[data-res-scrub]', root).forEach(function (p) {
      if (p.__reswords) return;
      var words = [];
      (function split(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
          if (ch.nodeType === 3) {
            var frag = document.createDocumentFragment();
            ch.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var s = document.createElement('span'); s.className = 'res-w'; s.textContent = w;
              if (node.closest && node.closest('em, strong, b, i, [data-hl]') && node !== p) s.setAttribute('data-hl', '1');
              frag.appendChild(s); words.push(s);
            });
            ch.parentNode.replaceChild(frag, ch);
          } else if (ch.nodeType === 1) { split(ch); }
        });
      })(p);
      p.__reswords = words;
      scrubs.push(p);
    });
  }

  /* ---------- Recorrido: fila de paneles deslizable (sin bloquear el scroll) ----------
     Se desliza con el dedo, las flechas, los hitos de kilómetro o el teclado. Avanza solo cada N s mientras
     está en pantalla y se detiene para siempre cuando la persona interactúa (o tras dos vueltas). */
  function initRoute(root) {
    $$('[data-res-route]', root).forEach(function (r) {
      if (r.__resinit) return;
      r.__resinit = true;
      var track = $('[data-res-track]', r), panels = $$('.res-panel', r), kms = $$('[data-res-km-dot]', r);
      var fill = $('[data-res-route-fill]', r), label = $('[data-res-km]', r);
      var prev = $('[data-res-route-prev]', r), next = $('[data-res-route-next]', r);
      var n = panels.length;
      if (!track || !n) return;
      function pos(i) { return panels[i].offsetLeft - panels[0].offsetLeft; }
      function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      function index() {
        if (atEnd()) return n - 1; // el último panel puede no alinearse al inicio
        var x = track.scrollLeft, best = 0, d = Infinity;
        for (var i = 0; i < n; i++) { var dd = Math.abs(pos(i) - x); if (dd < d) { d = dd; best = i; } }
        return best;
      }
      function update() {
        var i = index();
        kms.forEach(function (k, j) { k.classList.toggle('res-on', j <= i); k.setAttribute('aria-current', j === i ? 'step' : 'false'); });
        panels.forEach(function (p, j) { p.classList.toggle('res-near', j === i); });
        if (fill) fill.style.transform = 'scaleX(' + (n > 1 ? i / (n - 1) : 1) + ')';
        if (label) label.textContent = String(i + 1).padStart(2, '0');
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === n - 1;
        r.__residx = i;
      }
      var target = 0;
      function go(i) {
        target = Math.max(0, Math.min(n - 1, i));
        clearTimeout(track.__resmt);
        // Respaldo: si el desplazamiento suave no llegó, salta directo
        track.__resmt = setTimeout(function () {
          if (index() !== target) track.scrollLeft = pos(target);
          update();
        }, 650);
        track.scrollTo({ left: pos(target), behavior: reduce ? 'auto' : 'smooth' });
      }
      var auto = !reduce && !designMode && n > 1 && 'IntersectionObserver' in window;
      var dur = (+r.getAttribute('data-res-autoplay') || 5) * 1000;
      var timer = null, stopped = !auto, visible = false, ticks = 0;
      function stop() { stopped = true; clearTimeout(timer); }
      function schedule() {
        clearTimeout(timer);
        if (stopped || !visible || document.hidden) return;
        timer = setTimeout(function () {
          if (++ticks >= n * 2) { stop(); return; }
          var cur = r.__residx || 0;
          go(cur + 1 >= n ? 0 : cur + 1);
          schedule();
        }, dur);
      }
      if (prev) prev.addEventListener('click', function () { stop(); go((r.__residx || 0) - 1); });
      if (next) next.addEventListener('click', function () { stop(); go((r.__residx || 0) + 1); });
      kms.forEach(function (k, j) { k.addEventListener('click', function () { stop(); go(j); }); });
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (t) { track.addEventListener(t, stop, { passive: true }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go((r.__residx || 0) - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go((r.__residx || 0) + 1); }
      });
      // La posición se lee en el listener único de scroll (captura) y al terminar el desplazamiento
      track.__resupdate = update;
      track.addEventListener('scrollend', update, { passive: true });
      r.__resstop = stop;
      r.__resgo = go;
      update();
      if (!auto) return;
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting && es[0].intersectionRatio >= 0.35;
        schedule();
      }, { threshold: [0, 0.35] }).observe(r);
      document.addEventListener('visibilitychange', schedule);
    });
  }

  /* ---------- Scroll (único listener) ---------- */
  var ticking = false;
  function onScroll() {
    ticking = false;
    var vh = window.innerHeight;
    scrubs = scrubs.filter(function (p) { return p.isConnected; });
    scrubs.forEach(function (p) {
      var words = p.__reswords;
      var r = p.getBoundingClientRect();
      var pr = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var lit = Math.round(pr * words.length * 1.15);
      words.forEach(function (w, i) {
        var on = reduce || designMode || i < lit;
        w.style.opacity = on ? 1 : 0.16;
        w.classList.toggle('res-hl', on && w.getAttribute('data-hl') === '1');
      });
    });
    if (!reduce) {
      $$('[data-res-parallax]').forEach(function (im) {
        var rr = im.parentElement.getBoundingClientRect();
        if (rr.bottom < 0 || rr.top > vh) return;
        var c = (rr.top + rr.height / 2 - vh / 2) / vh;
        im.style.transform = 'translateY(' + (c * -100 * (+im.getAttribute('data-res-parallax'))) + '%)';
      });
    }
    var bar = $('[data-res-buybar]');
    if (bar) {
      var hero = $('[data-res-hero]'), order = document.getElementById('pedido');
      var passed = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > vh;
      var orderVisible = false;
      if (order) { var ob = order.getBoundingClientRect(); orderVisible = ob.top < vh && ob.bottom > 0; }
      bar.classList.toggle('res-show', passed && !orderVisible);
    }
  }
  function requestTick(e) {
    var t = e && e.target;
    if (t && t.__resupdate) { if (!t.__resraf) t.__resraf = requestAnimationFrame(function () { t.__resraf = 0; t.__resupdate(); }); return; }
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }

  /* ---------- Arranque ---------- */
  function init(root) {
    initGallery(root);
    initScrub(root);
    initRoute(root);
    initReveal(root);
  }
  function boot() {
    if (designMode) document.documentElement.classList.add('res-design-mode');
    initState();
    // Las ofertas de Releasit se leen al cargar; si la app aún no está lista, se reintenta al terminar la carga
    if (!applyCodOffers()) window.addEventListener('load', function () { applyCodOffers(); setTimeout(applyCodOffers, 1500); });
    init(document);
    // En captura sobre document: recibe el scroll de window y también el de un contenedor con overflow
    // (Horizon puede desplazar un contenedor en lugar de la ventana). Un solo listener.
    document.addEventListener('scroll', requestTick, { passive: true, capture: true });
    window.addEventListener('resize', requestTick, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Personalizador: re-inicia la sección que se vuelve a renderizar
  document.addEventListener('shopify:section:load', function (e) { initState(); applyCodOffers(); init(e.target); requestTick(); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[data-i]');
    var route = e.target.closest('[data-res-route]');
    if (route && panel && route.__resgo) { route.__resstop(); route.__resgo(+panel.getAttribute('data-i')); }
  });
})();
